<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div v-else>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-12">
                  <b-form-group
                    class="mb-3"
                    label="Tipo de Documento"
                    :state="stateTpDocumento"
                  >
                    <multiselect
                      v-model="dados.tpDocumento"
                      placeholder="Selecione"
                      :show-labels="false"
                      label="ds_tipo_anexo"
                      :options="optionTpDocumento"
                      :disabled="disabledTpDocumento"
                    />
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <b-form-group class="mb-3" label="Data Inclusão">
                    <b-form-input
                      v-model="dados.dtInclusao"
                      type="text"
                      trim
                      autocomplete="off"
                      :disabled="true"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group class="mb-3" label="Situação">
                    <span
                      class="badge rounded-pill font-size-15 mt-1"
                      :class="{
                        'badge-soft-warning': dados.situacao === '0',
                        'badge-soft-info': dados.situacao === '1',
                        'badge-soft-success': dados.situacao === '2',
                        'badge-soft-danger': dados.situacao === '3',
                        'badge-soft-secondary': dados.situacao === '4',
                      }"
                    >
                      {{ getStatusName(dados.situacao) }}
                    </span>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 my-4">
                  <h4>Instruções</h4>
                  <span
                    >Certifique-se de que o documento esteja plano e sem dobras,
                    para evitar sombras ou distorções indesejadas. Verifique se
                    o documento está bem iluminado. Use uma fonte de luz natural
                    ou iluminação ambiente para obter melhores resultados. Se o
                    documento estiver em papel, posicione-o sobre uma superfície
                    de fundo neutro, como uma mesa limpa. Lembre-se de que, ao
                    tirar fotos de documentos, é importante garantir que todas
                    as informações sejam capturadas com clareza para garantir a
                    precisão e a legibilidade.
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row">
                <comprovante
                  v-model="dados.arquivo"
                  ref="comprovante"
                  v-bind:status="disabledInserirDoc"
                  normaOcrArquivo="N"
                  @enviar-ocr-data="atribuirArquivo"
                />
                <div v-if="dados.ds_caminho">
                  <label class="font-size-10" v-if="dados.dt_usualt !== '-'">
                    {{
                      dados.ds_caminho +
                      " - " +
                      dados.dt_usualt +
                      " - " +
                      dados.nm_usualt
                    }}
                  </label>
                  <label class="font-size-10" v-if="dados.dt_usualt === '-'">
                    {{
                      dados.ds_caminho +
                      " - " +
                      dados.dtInclusao +
                      " - " +
                      dados.nm_usuinc
                    }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="mt-1 d-flex justify-content-between">
              <div class="mx-2">
                <router-link to="/perfilPessoal/gestaoDocumentos">
                  <b-button
                    variant="primary"
                    data-tooltip="Voltar"
                    data-tooltip-location="bottom"
                  >
                    <i class="mdi mdi-arrow-left-circle font-size-15"></i>
                  </b-button>
                </router-link>
              </div>
              <div class="d-flex">  
                <div class="mx-1" v-if="dados.situacao != '4'">
                  <b-button
                    variant="dark"
                    data-tooltip="download"
                    @click="downloadDocumento(dados)"
                    data-tooltip-location="bottom"
                    :disabled="loadingDownloading"
                  >
                    <i class="mdi mdi-download font-size-15"></i>
                    <b-spinner
                      class="ms-2"
                      variant="primary"
                      small
                      v-if="loadingDownloading"
                    ></b-spinner>
                  </b-button>
                </div>
                <div>
                  <b-button
                    variant="success"
                    data-tooltip="Salvar"
                    data-tooltip-location="bottom"
                    @click="salvarDocumento"
                    :disabled="disabledSalvar"
                  >
                    <i class="mdi mdi-content-save font-size-15"></i>
                    <b-spinner
                      class="ms-2"
                      variant="primary"
                      small
                      v-if="loadingSalvar"
                    ></b-spinner>
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Interações</h4>
              <div role="tablist">
                <div>
                  <b-card
                    no-body
                    class="mb-1 shadow-none"
                    v-for="(field, index) in interacoes"
                    :key="index"
                  >
                    <a
                      class="m-0 text-dark"
                      v-b-toggle="`accordion-${index}`"
                      href="javascript:void(0)"
                    >
                      <b-card-header header-tag="header" role="tab">
                        <i class="mdi mdi-subdirectory-arrow-right" />
                        <!-- para alterar a data, tem que alterar procedure-->
                        {{ field.DATA }} -
                        {{ capitalizeString(field.NMUSUARIO) }} -
                        <span
                          class="badge rounded-pill font-size-12"
                          :class="{
                            'badge-soft-warning':
                              field.STUPLOADATUAL === 'PENDENTE',
                            'badge-soft-info':
                              field.STUPLOADATUAL === 'EM ANÁLISE',
                            'badge-soft-success':
                              field.STUPLOADATUAL === 'VÁLIDO',
                            'badge-soft-danger':
                              field.STUPLOADATUAL === 'INVÁLIDO',
                          }"
                        >
                          {{ capitalizeString(field.STUPLOADATUAL) }}
                        </span>
                      </b-card-header>
                    </a>
                    <b-collapse
                      :id="`accordion-${index}`"
                      :aria-labelledby="`accordion-${index}-header`"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <ul>
                          <li>
                            <strong>Observação: </strong>{{ field.DSMOTIVO }}
                          </li>
                        </ul>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import comprovante from "@/components/formulario/comprovante/comprovante";

export default {
  components: {
    PageHeader,
    Multiselect,
    comprovante,
  },

  data() {
    return {
      title: "Gestão de Documentos",
      items: [{}],
      loading: true,
      dados: {
        tpDocumento: "",
        dtInclusao: "",
        situacao: "",
        arquivo: { comprovante: null },
        sq_upload: "",
        ds_caminho: "",
        nm_incluido_por: "",
        dt_usualt: "",
        nm_usuinc: "",
      },
      interacoes: {},
      disabledTpDocumento: false,
      disabledInserirDoc: "",
      activeTab: "",
      optionTpDocumento: [],
      stateTpDocumento: null,
      loadingSalvar: false,
      loadingDownloading: false,
      disabledSalvar: false,
    };
  },

  async mounted() {
    window.scrollTo(0, 0);
    if (this.$route.params.id !== "0") {
      this.dados.sq_upload = this.$route.params.id;
      await this.buscarTipoDocumentos(false);
      await this.buscarDocumentosEComentarios(this.$route.params.id);

      if (this.dados.arquivo.comprovante) {
        this.$nextTick(() => {
          this.$refs.comprovante.setArquivo(this.dados.arquivo);
        });
      }
    } else {
      await this.buscarTipoDocumentos();
      this.dados.dtInclusao = this.getCurrentFormattedDate();
    }
  },

  methods: {
    state(param) {
      if (this.submit) {
        return !this.$v.dados[param].$invalid;
      } else {
        return null;
      }
    },

    async atribuirArquivo(ocrData, dataArquivo) {
      this.dados.arquivo = dataArquivo.arquivo;
    },

    async buscarTipoDocumentos(filtragem = true) {
      try {
        const responseInclusao = await this.$http.get(
          "api/cadastroCandidato/buscarTiposDocumentoInclusao"
        );
        if (filtragem) {
          this.optionTpDocumento = responseInclusao.data;
          this.dados.situacao = "4";
        } else {
          const responseDocumento = await this.$http.get(
            "api/cadastroCandidato/buscarTiposDocumento"
          );
          this.optionTpDocumento = responseDocumento.data;
          this.disabledTpDocumento = true;
        }
        this.loading = false;
      } catch (err) {
        console.error(err);
        this.loading = false;
      }
    },

    async buscarDocumentosEComentarios(id) {
      try {
        this.loading = true;
        const [documentosResponse, comentariosResponse] = await Promise.all([
          this.$http.get(`api/cadastroCandidato/buscarDocumentosById/${id}`),
          this.$http.get(`api/cadastroCandidato/buscarDocComentarios/${id}`),
        ]);

        //Documento
        const documentosData = documentosResponse.data;
        const {
          ds_titulo,
          dt_usuinc,
          st_upload,
          ds_caminho,
          nm_usualt,
          dt_usualt,
          nm_usuinc,
          ge_pes_upl,
        } = documentosData.wbupload;

        this.dados.tpDocumento = this.optionTpDocumento.find(
          (el) => el.sq_tipo_anexo === ge_pes_upl.sq_tipo_anexo
        );

        this.dados.tpDocumento.ds_tipo_anexo =
          this.dados.tpDocumento.ds_tipo_anexo +
          " - [" +
          this.dados.tpDocumento.sq_tipo_anexo +
          "][" +
          id +
          "]";

        const tpInclusao = this.dados.tpDocumento.tp_inclusao;
        this.dados.ds_titulo = ds_titulo;
        this.dados.dtInclusao = this.$tools.converteDataHora(dt_usuinc);
        this.dados.dt_usualt = this.$tools.converteDataHora(dt_usualt);
        this.dados.situacao = st_upload;
        this.dados.ds_caminho = ds_caminho;
        this.dados.nm_usualt = nm_usualt;
        this.dados.arquivo = documentosData.arquivo;
        this.dados.nm_usuinc = nm_usuinc;

        //Comentarios
        const comentariosData = comentariosResponse.data;
        this.interacoes = comentariosData;

        if (tpInclusao == "I") {
          if (st_upload == 1 || st_upload == 2) {
            this.disabledInserirDoc = "V";
            this.disabledSalvar = true;
          }
        } else if (tpInclusao == "E") {
          if (st_upload == 2) {
            this.disabledInserirDoc = "V";
            this.disabledSalvar = true;
          }
        } else {
          this.disabledInserirDoc = "V";
          this.disabledSalvar = true;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$tools.alerta("Documento não encontrado", "error");
        this.$router.push({ path: "/perfilPessoal/gestaoDocumentos" });
      }
    },

    salvarDocumento() {
      if (!this.dados.arquivo || !this.dados.tpDocumento) {
        this.handleCamposVazios();
        return;
      }
      this.stateTpDocumento = null;
      this.$refs.comprovante.validate(false);
      var item = {
        sq_upload: this.dados.sq_upload,
        ds_titulo: this.dados.tpDocumento.ds_tipo_anexo,
        sq_tipo_anexo: this.dados.tpDocumento.sq_tipo_anexo,
        arquivo: this.dados.arquivo.comprovante,
        extensaoArquivo: this.dados.arquivo.tipoComprovante,
      };
      this.loadingSalvar = true;
      this.disabledSalvar = true;

      this.$http
        .post("api/cadastroCandidato/uploadDigitalizado", item)
        .then(() => {
          this.$tools.alerta("Documento cadastrado com sucesso", "success");
          this.$router.push({ path: "/perfilPessoal/gestaoDocumentos" });
        })
        .catch((error) => {
          this.$tools.alerta(error, "error");
        })
        .finally(() => {
          this.loadingSalvar = false;
          this.disabledSalvar = false;
        });
    },

    async downloadDocumento(data) {
      this.loadingDownloading = true
      if (this.dados.tpDocumento.tp_inclusao === "G") {
        var nomeArquivo = this.dados.ds_caminho.replace('.pdf', '');
        await this.buscarDocZip(nomeArquivo);
        return;
      }
      if (!data.arquivo.comprovante) {
        this.$tools.alerta("Documento não encontrado", "error");
        return;
      }
      const base64Data = data.arquivo.comprovante.split(",")[1];
      const match = data.arquivo.comprovante.match(/:(.*?);/);
      const byteArray = new Uint8Array([...atob(base64Data)].map((char) => char.charCodeAt(0)));
      const blob = new Blob([byteArray], { type: match[1] });
      this.downloadFile(
        blob,
        `${data.ds_titulo.replace(/[^\w\s.]/gi, "_")}.${data.arquivo.tipoComprovante}`
      );
      this.loadingDownloading = false;
    },

    downloadFile(content, fileName){
      const fileUrl = URL.createObjectURL(content);
      const a = Object.assign(document.createElement("a"), {
        style: "display: none",
        href: fileUrl,
        download: fileName,
      });
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(fileUrl);
      this.loadingDownloading = false;
    },

    async buscarDocZip(nomeArquivo) {
      try {
        const response = await this.$http.get(`api/cadastroCandidato/buscarArquivoZip/${nomeArquivo}/${this.$route.params.id}`, {
          responseType: 'blob',
        });
        const blob = new Blob([response.data], { type: 'application/zip' });
        this.downloadFile(blob, `${nomeArquivo}.zip`);
      } catch (error) {
        this.loadingDownloading = false;
        console.error('Erro ao baixar o arquivo:', error);
      }
    },


    handleCamposVazios() {
      if (!this.dados.tpDocumento) {
        this.stateTpDocumento = false;
      } else {
        this.stateTpDocumento = null;
      }
      if (!this.dados.arquivo) {
        this.$refs.comprovante.validate(true);
        this.$tools.alerta("Selecione um documento para salvar", "warning");
      } else {
        this.$refs.comprovante.validate(false);
        this.$tools.alerta("Preencha o Tipo de Documento", "warning");
      }
    },

    capitalizeString(str) {
      if (!str) return "";
      return str
        .split(" ")
        .map((word) => {
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(" ");
    },

    getStatusName(stUpload) {
      const statusMap = {
        0: "Pendente",
        1: "Em Análise",
        2: "Válido",
        3: "Inválido",
        4: "Nova Documentação",
      };
      return statusMap[stUpload] || "Indefinido";
    },

    getCurrentFormattedDate() {
      const dataHoraAtual = new Date();
      const formatoDataHora = `${dataHoraAtual.getFullYear()}-${(
        dataHoraAtual.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}-${dataHoraAtual
        .getDate()
        .toString()
        .padStart(2, "0")} ${dataHoraAtual
        .getHours()
        .toString()
        .padStart(2, "0")}:${dataHoraAtual
        .getMinutes()
        .toString()
        .padStart(2, "0")}:${dataHoraAtual
        .getSeconds()
        .toString()
        .padStart(2, "0")}`;
      return this.$tools.converteDataHora(formatoDataHora);
    },
  },
};
</script>
